/**
 * A custom element that manages the account login actions.
 *
 * @extends {HTMLElement}
 */
class AccountLoginActions extends HTMLElement {
  /**
   * @type {Element | null}
   */
  shopLoginButton = null;

  connectedCallback() {
    // v250: der Shop-Login-Button liegt in einem <template> und wird erst bei der ersten Interaktion
    // (oder nach 8 s) eingesetzt. Vorher luden ~30 Shop-JS-Module + ein shop.app-iframe beim Seitenaufbau.
    const template = this.querySelector('template[data-shop-login]');
    if (!template) {
      this.#setup();
      return;
    }

    const events = ['pointerdown', 'touchstart', 'keydown', 'mouseover', 'focusin'];
    let done = false;
    const inject = () => {
      if (done) return;
      done = true;
      events.forEach((name) => window.removeEventListener(name, inject, true));
      clearTimeout(timer);
      if (!template.isConnected) return;
      template.replaceWith(document.importNode(template.content, true));
      this.#setup();
    };
    events.forEach((name) => window.addEventListener(name, inject, { capture: true, passive: true }));
    const timer = setTimeout(inject, 8000);
  }

  #setup() {
    this.shopLoginButton = this.querySelector('shop-login-button');

    if (this.shopLoginButton) {
      // We don't have control over the shop-login-button markup, so we need to set additional attributes here
      this.shopLoginButton.setAttribute('full-width', 'true');
      this.shopLoginButton.setAttribute('persist-after-sign-in', 'true');
      // Do this only if New Customer Account is ALWAYS the sign in option (and never Classic Customer Account)
      this.shopLoginButton.setAttribute('analytics-context', 'loginWithShopSelfServe');
      this.shopLoginButton.setAttribute('flow-version', 'account-actions-popover');
      this.shopLoginButton.setAttribute('return-uri', window.location.href);

      // Reload the page after the login is completed, otherwise the page state is incorrect
      this.shopLoginButton.addEventListener('completed', () => {
        window.location.reload();
      });
    }
  }
}

if (!customElements.get('account-login-actions')) {
  customElements.define('account-login-actions', AccountLoginActions);
}
